import { DataFormats } from '@skylab-shared/constants';
import { L10nBase } from '@skylab-shared/core';
import { DataExchangeKind, JpkVatSubkind } from '@skylab-shared/dataModel';
import { TypeOf } from '@skylab-shared/types';
import { dateDiffInDays, getMonthRange, getQuarterNumber, getQuarterRange } from '@skylab-shared/utils';
import { format } from 'fecha';


type AccountancyDetails = { from: Date; to: Date; kind: DataExchangeKind | JpkVatSubkind; };

export class AccountancyPeriodDescriptorBase {
    public constructor(
        private readonly l10n: L10nBase
    ) { }

    public describe(data: AccountancyDetails): string {
        if (this.isQuarterlyDataExchange(data.kind) && this.isDateForWholeQuarter(data.from, data.to)) {
            const quarter = this.l10n._T(`business.accountancy.period.quater.${getQuarterNumber(data.from)}`);
            const year = data.from.getFullYear();
            return `${quarter} ${year}`;
        }
        return this.isDateForWholeMonth(data.from, data.to)
            ? format(data.from, DataFormats.date.monthYearFormat)
            : `${format(data.from, DataFormats.date.short)} - ${format(data.to, DataFormats.date.short)}`;
    }

    private isQuarterlyDataExchange(kind: TypeOf<AccountancyDetails, 'kind'>): boolean {
        return kind === JpkVatSubkind.JPK_V7K;
    }

    private isDateForWholeQuarter(start: Date, end: Date): boolean {
        const { firstDay: quarterStart, lastDay: quarterEnd } = getQuarterRange(start);
        return dateDiffInDays(start, quarterStart) === 0 && dateDiffInDays(end, quarterEnd) === 0;
    }

    private isDateForWholeMonth(start: Date, end: Date): boolean {
        const { firstDay, lastDay } = getMonthRange(start);
        return dateDiffInDays(start, firstDay) === 0 && dateDiffInDays(end, lastDay) === 0;
    }
}
